import Field from './modules/field';
import { listenBlockSizes, setBlockSizes, setLocks } from './utils';

export default function globalModules() {
  listenBlockSizes();
  setBlockSizes();
  setLocks();
  window.addEventListener('resize', setBlockSizes);

  const fields = document.querySelectorAll('.field');
  fields.forEach((field) => new Field(field));
}
